var _defs, _path, _path2, _circle, _rect, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "I",
    xmlns: "http://www.w3.org/2000/svg",
    width: 590,
    height: 295,
    viewBox: "0 0 590 295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: #204b9a;\n      }\n\n      .cls-1, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-4 {\n        fill: #66b42d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "cls-1",
    d: "M373,165l32-17s-27.056-41.711-77-36-78,47.465-78,78,17.74,86,81,86,71-32,71-32l-28-20s-9.385,16-41,16-45-17.242-45-46,18.274-46,44-46A58.428,58.428,0,0,1,373,165Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-1",
    d: "M132,275l-1-103s-3.485-23-27-23c-18.068,0-29.616,24.191-34,35.405v93.033H32v-163H70v16.971c8.146-6.854,27.722-21,49-19.408,27.957,2.089,48.878,28.01,49,41s1,122,1,122H132Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "I-2",
    "data-name": "I",
    className: "cls-2",
    cx: 207.5,
    cy: 78.625,
    r: 26.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "I-3",
    "data-name": "I",
    className: "cls-3",
    x: 192,
    y: 112,
    width: 38,
    height: 163
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-1",
    d: "M490.594,112a81.5,81.5,0,1,1-81.5,81.5A81.5,81.5,0,0,1,490.594,112Zm0,33.906A47.594,47.594,0,1,1,443,193.5,47.595,47.595,0,0,1,490.594,145.906Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Casita",
    className: "cls-4",
    d: "M23,87l8,21L205,43,358,86V43h16V94l194,17V89L397,74V21H336V56L206,19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.30804cb867c10881e34bc44c20cb3f42.svg";
export { ForwardRef as ReactComponent };